import { createContext, Dispatch, SetStateAction, useContext } from 'react';
import { RequestType } from 'models/item-request.model';

export type ItemRequestContextType = {
  setItemRequestToEdit: Dispatch<SetStateAction<RequestType>>;
  itemRequestToEdit: RequestType;
};

export const ItemRequestContext = createContext({} as ItemRequestContextType);
const useItemRequestContext = () => {
  const context = useContext(ItemRequestContext);
  return context;
};

export default useItemRequestContext;
